import axios from 'axios';

class StripeService {

    async getPaymentFlowDetails(companyId, invoiceId, signature) {
        console.log("[StripeService][getPaymentFlowDetails] Getting payment flow details for invoiceId ", invoiceId);
        return await axios.get(`/api/stripe/pay/${companyId}/${invoiceId}/${signature}`);
    }

    async getPaymentStatus(paymentReference) {
        console.log("[StripeService][getPaymentStatus] Getting payment status for paymentReference ", paymentReference);
        return await axios.get(`/api/stripe/pay/status/${paymentReference}`);
    }
}

export default new StripeService();
